export const GET_TOP_VALIDATORS_START = 'INFO/GET_TOP_VALIDATORS_START';
export const GET_TOP_VALIDATORS_SUCCESS = 'INFO/GET_TOP_VALIDATORS_SUCCESS';
export const GET_TOP_VALIDATORS_ERROR = 'INFO/GET_TOP_VALIDATORS_ERROR';
export const UPDATE_TOP_VALIDATORS = 'INFO/UPDATE_TOP_VALIDATORS';
